import React, { useState } from 'react'
import { OverlayTrigger, Tooltip, Button, Spinner } from 'react-bootstrap'
import { connect } from 'react-redux'
import { DEPARTMENT_HEADS } from '../../constants/roles'

const ExportChiefReportButton = ({ auth, callback, onError, icon = null, title, loadingTitle = '', tooltipText, variant = 'primary' }) => {
  const [loading, setLoading] = useState(false);

  const clickHandler = () => {
    setLoading(true);

    callback()
      .catch(onError)
      .then(() => setLoading(false));
  }

  if (DEPARTMENT_HEADS.includes(auth.user.role)){
    return (
     <OverlayTrigger
       overlay={
         <Tooltip>
          <strong>{tooltipText}</strong>
         </Tooltip>
       }
     >
      <Button variant={variant} onClick={clickHandler} disabled={loading}>
        {loading 
          ? <><Spinner size="sm" className="align-middle" animation="border" variant="light" /> {loadingTitle || title}</>
          : <>{icon}{title}</>
        }
      </Button>
     </OverlayTrigger>
   )
  }
  return null
}
export default connect(({ auth })=>({ auth }))(ExportChiefReportButton)